import React, { useState } from "react";
import {
  Box,
  Grid,
  Input,
  Button,
  Spacer,
  PageTitle,
  Text,
  EmptyState,
  FlexiPagination,
} from "@flexisaf/flexibull2";

import Theme from "../../theme";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import useGetAllTopics from "../../hooks/auto-complete/useGetAllTopics";
import SectionLoader from "../../components/custom/sectionLoader";
import DeleteModal from "../../components/DeleteModal/DeleteModal";

const Topics = () => {
  const { subjectName } = useParams();
  const {
    topics,
    searchText,
    setSearchText,
    paginatedList,
    loadingTopics,
    pageOptions,
    totalElements,
    limit,
    setPage,
    setLimit,
    page,
    setOffset,
    deleteTopic,
    isDeletingTopic,
    refetch,
  } = useGetAllTopics({
    subjectName,
  });

  const [deleteTopicModal, setDeleteTopicModal] = useState({
    openModal: false,
    data: null,
  });

  const handleDelete = (data) => {
    let payload = {
      data: { key: subjectName, value: data },
      cb: () => {
        setDeleteTopicModal({
          openModal: false,
          data: null,
        });
        refetch();
      },
    };
    deleteTopic(payload);
  };

  if (loadingTopics)
    return <SectionLoader height="70vh" color={Theme.PrimaryColor} />;
  return (
    <Box>
      <PageTitle>
        <i className="saf-document" />
        <Text bold title="CBT" size={Theme.H3} style={{ padding: "0 10px" }}>
          Topics
        </Text>
      </PageTitle>
      <Text bold capitalize size={Theme.H3}>
        {subjectName} Topics
      </Text>
      <Text size="1.rem" color={Theme.PrimaryGrey} block>
        Total Results: {topics.length}
      </Text>
      <Spacer space={10} />
      <Box>
        <Grid
          default="minmax(auto, 400px)  minmax(auto, 300px) auto max-content max-content"
          sm="1fr"
        >
          <Input
            name="search"
            placeholder="Search topic"
            iconLeft="saf-search-normal"
            onChange={(e) => setSearchText(e.target.value)}
            value={searchText}
          />
          <Box />
          <Box />
        </Grid>
        <Spacer height="40px" />
        {paginatedList.length > 0 ? (
          <>
            <Grid default="1fr 1fr 1fr 1fr" gap="20px">
              {paginatedList.map((topic, index) => {
                return (
                  <TopicsCard key={index}>
                    <Box pad="10px">
                      <Text>{topic}</Text>
                    </Box>
                    <Button
                      color={Theme.PrimaryRed}
                      plain
                      onClick={() =>
                        setDeleteTopicModal({ openModal: true, data: topic })
                      }
                    >
                      <i className="saf-trash" style={{ fontSize: "1rem" }} />
                    </Button>
                  </TopicsCard>
                );
              })}
            </Grid>
            <FlexiPagination
              pageCounts={pageOptions}
              itemsDisplayed
              total={totalElements}
              pageSize={limit}
              onChange={(page) => {
                setPage(page);
                setOffset((page - 1) * limit);
              }}
              changePageSize={({ value }) => {
                setPage(1);
                setLimit(value);
              }}
              current={page}
            />
          </>
        ) : (
          <Box>
            <EmptyState type="documents" title="No topic found." />
          </Box>
        )}
      </Box>
      <DeleteModal
        isOpen={deleteTopicModal.openModal}
        onClose={() => setDeleteTopicModal({ openModal: false, data: null })}
        title="Delete Topic"
        description={`Are you sure you want to delete the topic "${deleteTopicModal?.data}"? You can't undo this action.`}
        isLoading={isDeletingTopic}
        onDelete={() => {
          handleDelete(deleteTopicModal?.data);
          document.body.style.overflow = "auto";
        }}
      />
    </Box>
  );
};

export default Topics;

const TopicsCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  border-radius: 8px;
`;
